export function assignStyle(
  element: HTMLElement,
  style: Partial<CSSStyleDeclaration>
) {
  const prevStyle = element.style.cssText;

  Object.assign(element.style, style);

  return () => {
    element.style.cssText = prevStyle;
  };
}
